import p2pLogo from '../../img/p2p-logo.png';
import emailLogo from '../../img/mail.png';
import telegramLogo from '../../img/telegram-logo.png'
import { GET_LOGO } from '../constans';

export interface ImagesState {
  [key: string]: string;
}

interface GetLogoAction {
  type: typeof GET_LOGO;
  payload: string[];
}

const img = {
  'p2pLogo': p2pLogo,
  'emailLogo': emailLogo,
  'telegramLogo': telegramLogo,
}

const initialState: ImagesState = {};

export const imagesReducer = (state = initialState, action: GetLogoAction): ImagesState => {
  switch (action.type) {
    case GET_LOGO: {
      const newState = { ...state };
      action.payload.forEach((logo) => {
        newState[logo] = img[logo];
      });
      return newState;
    }

    default:
      return state;
  }
};

export const getLogos = (logoKeys: string[]) => ({
  type: GET_LOGO,
  payload: logoKeys,
});
